import React, {useEffect, useState} from 'react'
import {Container, Row, Col, Image} from 'react-bootstrap';
import {FaTwitter, FaLinkedin, FaBasketballBall, FaFacebookF} from "react-icons/fa";
import {AiFillInstagram} from "react-icons/ai";
import {useInView} from 'react-intersection-observer';


import './Footer.css'
import CustomButton from "../../components/accesories/customBtn/CustomButton";
import {Link} from "react-router-dom";
import useHandleRequest from "../../custom_hooks/useHandleRequest";
import {useData} from "../../context/DataContext";

function Footer(props) {
    const {handleRequestAndNavigate} = useHandleRequest();
    const [ref, inView] = useInView({
        threshold: 0.9, // زمانی که 10% المان وارد دید شود، تریگر شود
        triggerOnce: false, // فقط یکبار انیمیشن اجرا شود
    });
    const {data,fetchData} = useData();
    const [contactUsData, setContactUsData] = useState([])

    useEffect(() => {
        if (data.contact_us.length === 0) {
            fetchData("contact_us", "contact-us/");
        }
    }, []);
    useEffect(() => {
        if (data.contact_us.length > 0) {
            setContactUsData(data.contact_us);
        }
    }, [data.contact_us]);

    return (
        <footer className={'container-fluid footer'}>
            <Container className={'footer-container'}>
                <Row className={'footer-up-row'}>
                    <Col sm={12} lg={6} xl={5} className={'first-col ms-0 ps-5'}>
                        <Link
                            to="/"
                            className={`logo ${inView ? 'animate__animated animate__swing animate__delay-1s' : ''}`}
                            ref={ref}
                        >
                            <img src={'/static/images/img.png'} alt="logo"/>
                        </Link>
                        <p>گروه نرم افزاری داده پرداز پیشرو تبرستان (<span>داپا</span>) با بیش از 7 سال سابقه در طراحی
                            سایت،
                            اپلیکیشن، سئو و سایر خدمات <span>نرم افزاری</span> آماده است همراه شما در دنیای جدید کسب و
                            کارتان باشد.
                            برای کسب اطلاعات بیش تر با ما در ارتباط باشید.</p>
                        {/*<ul className={'footer-social-icons'}>
                            <li><a href="#" className="footer-social-icon"><FaFacebookF/></a></li>
                            <li><a href="#" className="footer-social-icon"><FaBasketballBall/></a></li>
                            <li><a href="#" className="footer-social-icon"><AiFillInstagram/></a></li>
                            <li><a href="#" className="footer-social-icon"><FaLinkedin/></a></li>
                            <li><a href="#" className="footer-social-icon"><FaTwitter/></a></li>
                        </ul>*/}
                    </Col>
                    <Col sm={12} lg={6} xl={7}>
                        <Row>
                            <Col sm={3} xl={3} className={"d-none d-xl-block"}>
                                <h5>صفحات</h5>
                                <ul className={'footer-links'}>
                                    <li><a onClick={(e) => handleRequestAndNavigate(e, '/blogs', 'blogs/', 'blogs')} className="footer-link">بلاگ</a></li>
                                    <li><a onClick={(e) => handleRequestAndNavigate(e, '/contact-us', 'contact-us/', 'contact_us')}
                                           className="footer-link">تماس با ما</a></li>

                                    <li><a onClick={(e) => handleRequestAndNavigate(e, '/faq', 'faq/', 'faq')}
                                           className="footer-link">پرسش‌های متداول</a></li>
                                    <li><a onClick={(e) => handleRequestAndNavigate(e, '/about-us', 'about-us/', 'about_us')}  className="footer-link">درباره ما</a></li>
                                </ul>
                            </Col>
                            <Col sm={3} xl={3} className={"d-none d-xl-block"}>
                                <h5>خدمات</h5>
                                <ul className={'footer-links'}>
                                    <li><a
                                        onClick={(e) => handleRequestAndNavigate(e, '/events', 'events/', 'events')}
                                        className="footer-link">رویدادها</a></li>

                                    <li><a href="#" className="footer-link">آکادمی داپا</a></li>
                                    <li><a href="#" className="footer-link">ثبت نام در آکادمی</a></li>
                                    <li><a href="#" className="footer-link">مشاوره داپا</a></li>
                                </ul>

                            </Col>
                            <Col lg={12} xl={6} className={'news-letter'}>
                                <h5>خبرنامه</h5>
                                <p>برای دریافت آخرین اخبار، مقالات و تخفیف‌های ویژه، ایمیل خود را وارد کنید. همراه شما
                                    در دنیای تکنولوژی خواهیم بود.</p>
                                <div className={'follow-us'}>
                                    <input type="email" placeholder={'پست الکترونیکی @'} formNoValidate/>
                                    <CustomButton isLink href={'#'} bgColor={'#00A378'}  text={'دنبال کردن'} width={'8rem'}
                                                  height={'100%'}/>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className={'footer-middle-row'}>
                    <Col xl={6} md={6}>
                        <div className={'iframe-wrapper'}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1958.6566209544583!2d53.07220679403831!3d36.66778409313178!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8513147eb9b395%3A0x8b4a3bcd3262c56a!2zTTM5Qys1WCwgTW9qaSwgTWF6YW5kYXJhbiBQcm92aW5jZSwg2KfbjNix2KfZhg!5e0!3m2!1sfa!2s!4v1744280140681!5m2!1sfa!2s"
                                allowFullScreen="" loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </Col>
                    <Col xl={1} className={"d-none d-xl-block"}></Col>
                    <Col xl={5} md={6} className={'comment-col px-4 px-xl-0 ps-xl-2'}>
                        <Row className={'comments-parts d-flex flex-column'}>
                            <Col className={'p-0'}>
                                <div className={'address'}>
                                    <p className={'mb-3'}><i
                                        className="fa-solid fa-location-dot"></i>
                                        {
                                            contactUsData.length > 0 &&
                                            <>
                                                {contactUsData[0].address}
                                            </>
                                        }
                                        </p>
                                    <div className={'phone-number'}>
                                        <div className="right-part">
                                            <i className="fa-regular fa-phone-flip"></i>
                                            {contactUsData.length > 0 &&
                                                <a href={`tel:${contactUsData[0].phone_number}`}> {contactUsData[0].phone_number}</a>
                                            }

                                        </div>
                                        <div className="left-part">
                                            <ul className={'footer-social-icons'}>
                                                <li><a href="#" className="footer-social-icon"><FaFacebookF/></a></li>
                                                <li><a href="#" className="footer-social-icon"><AiFillInstagram/></a>
                                                </li>
                                                <li><a href="#" className="footer-social-icon"><FaLinkedin/></a></li>
                                                <li><a href="#" className="footer-social-icon"><FaTwitter/></a></li>
                                            </ul>
                                        </div>
                                    </div>


                                </div>
                                <Row className={'mt-5'}>
                                    <Col className={'footer-certificate-col d-flex align-items-center justify-content-end column-gap-3'}>
                                        {/*<Image src={'/static/images/enamad.png'}/>*/}
                                        {/*<Image src={'/images/enamad.png'}/>*/}
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="footer-third-row">
                </Row>
                <div className={'footer-divider'}></div>
                <Row md={12} className={'footer-down-row'}>
                    <Col>
                        <div>
                            کلیه حقوق این سایت متعلق به <a href='#'>گروه نرم افزاری داپا</a> است
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;